import { defineSemanticTokens } from "@chakra-ui/react"
// More info https://www.chakra-ui.com/docs/theming/colors#semantic-tokens
export const colors = defineSemanticTokens.colors({
  bg: {
    DEFAULT: {
      // Deepest
      value: {
        _dark: "{colors.gray.950}",
        _light: "{colors.gray.100}",
      },
    },
    emphasized: {
      // Closer
      value: {
        _dark: "{colors.gray.800}",
        _light: "{colors.gray.200}",
      },
    },
    error: {
      value: {
        _dark: "{colors.red.950}",
        _light: "{colors.red.50}",
      },
    },
    info: {
      value: {
        _dark: "{colors.blue.950}",
        _light: "{colors.blue.50}",
      },
    },
    inverted: {
      value: {
        _dark: "{colors.white}",
        _light: "{colors.black}",
      },
    },
    muted: {
      // Close
      value: {
        _dark: "{colors.gray.950}",
        _light: "{colors.gray.100}",
      },
    },
    panel: {
      // For cards & pannels Backgrounds
      value: {
        _dark: "{colors.gray.950}",
        _light: "{colors.white}",
      },
    },
    paper: {
      // Closest
      value: {
        _dark: "{colors.gray.900}",
        _light: "{colors.white}",
      },
    },
    primary: {
      value: {
        _dark: "{colors.primary.600}",
        _light: "{colors.primary.500}",
      },
    },
    subtle: {
      // Deep
      value: {
        _dark: "{colors.gray.900}",
        _light: "{colors.gray.50}",
      },
    },
    success: {
      value: {
        _dark: "{colors.green.950}",
        _light: "{colors.green.50}",
      },
    },
    warning: {
      value: {
        _dark: "{colors.orange.950}",
        _light: "{colors.orange.50}",
      },
    },
  },
  blue: {
    contrast: {
      value: {
        _dark: "white",
        _light: "white",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.blue.700}",
        _light: "{colors.blue.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.blue.300}",
        _light: "{colors.blue.700}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.blue.600}",
        _light: "{colors.blue.600}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.blue.800}",
        _light: "{colors.blue.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.blue.600}",
        _light: "{colors.blue.600}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.blue.900}",
        _light: "{colors.blue.100}",
      },
    },
  },
  border: {
    DEFAULT: {
      value: {
        _dark: "{colors.gray.800}",
        _light: "{colors.gray.200}",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.gray.700}",
        _light: "{colors.gray.300}",
      },
    },
    error: {
      value: {
        _dark: "{colors.red.400}",
        _light: "{colors.red.500}",
      },
    },
    info: {
      value: {
        _dark: "{colors.blue.400}",
        _light: "{colors.blue.500}",
      },
    },
    inverted: {
      value: {
        _dark: "{colors.gray.200}",
        _light: "{colors.gray.800}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.gray.900}",
        _light: "{colors.gray.100}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.gray.900/80}",
        _light: "{colors.gray.50}",
      },
    },
    success: {
      value: {
        _dark: "{colors.green.400}",
        _light: "{colors.green.500}",
      },
    },
    warning: {
      value: {
        _dark: "{colors.orange.400}",
        _light: "{colors.orange.500}",
      },
    },
  },
  cyan: {
    contrast: {
      value: {
        _dark: "white",
        _light: "white",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.cyan.700}",
        _light: "{colors.cyan.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.cyan.300}",
        _light: "{colors.cyan.700}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.cyan.600}",
        _light: "{colors.cyan.600}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.cyan.800}",
        _light: "{colors.cyan.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.cyan.600}",
        _light: "{colors.cyan.600}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.cyan.900}",
        _light: "{colors.cyan.100}",
      },
    },
  },
  fg: {
    DEFAULT: {
      value: {
        _dark: "{colors.gray.50}",
        _light: "{colors.black}",
      },
    },
    error: {
      value: {
        _dark: "{colors.red.400}",
        _light: "{colors.red.500}",
      },
    },
    info: {
      value: {
        _dark: "{colors.blue.300}",
        _light: "{colors.blue.600}",
      },
    },
    inverted: {
      value: {
        _dark: "{colors.black}",
        _light: "{colors.gray.50}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.gray.400}",
        _light: "{colors.gray.600}",
      },
    },
    read: {
      value: {
        _dark: "{colors.gray.200}",
        _light: "{colors.gray.800}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.gray.500}",
        _light: "{colors.gray.400}",
      },
    },
    success: {
      value: {
        _dark: "{colors.green.300}",
        _light: "{colors.green.600}",
      },
    },
    warning: {
      value: {
        _dark: "{colors.orange.300}",
        _light: "{colors.orange.600}",
      },
    },
  },
  gray: {
    contrast: {
      value: {
        _dark: "{colors.black}",
        _light: "{colors.white}",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.gray.700}",
        _light: "{colors.gray.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.gray.200}",
        _light: "{colors.gray.800}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.gray.200}",
        _light: "{colors.gray.800}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.gray.800}",
        _light: "{colors.gray.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.white}",
        _light: "{colors.gray.900}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.gray.900}",
        _light: "{colors.gray.100}",
      },
    },
  },
  green: {
    contrast: {
      value: {
        _dark: "white",
        _light: "white",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.green.700}",
        _light: "{colors.green.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.green.300}",
        _light: "{colors.green.700}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.green.600}",
        _light: "{colors.green.600}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.green.800}",
        _light: "{colors.green.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.green.600}",
        _light: "{colors.green.600}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.green.900}",
        _light: "{colors.green.100}",
      },
    },
  },
  nav: {
    bg: {
      value: {
        _dark: "{colors.white}",
        _light: "#1C1D21",
      },
    },
    contrast: {
      value: {
        _dark: "{colors.black}",
        _light: "{colors.white}",
      },
    },
  },
  navbar: {
    glass_bg: {
      value: {
        _dark: "rgba(10, 15, 30, 0.64)",
        _light: "rgba(255, 255, 255, 0.38)",
      },
    },
    glass_border: {
      value: {
        _dark: "rgba(255, 255, 255, 0.10)",
        _light: "rgba(255, 255, 255, 0.40)",
      },
    },
    solid_bg: {
      value: {
        _dark: "rgba(13, 19, 31, 0.95)",
        _light: "rgba(255, 255, 255, 0.95)",
      },
    },
  },
  navItem: {
    active: {
      value: {
        _dark: "{colors.black}",
        _light: "{colors.white}",
      },
    },
    bg: {
      value: {
        _dark: "{colors.transparent}",
        _light: "{colors.transparent}",
      },
    },
    bg_active: {
      value: {
        _dark: "{colors.primary.500}",
        _light: "{colors.white}",
      },
    },
    contrast: {
      value: {
        _dark: "{colors.gray.100}",
        _light: "{colors.gray.800}",
      },
    },
    contrast_active: {
      value: {
        _dark: "{colors.primary.100}",
        _light: "{colors.primary.500}",
      },
    },
    contrast_active_hover: {
      value: {
        _dark: "{colors.primary.100}",
        _light: "{colors.primary.400}",
      },
    },
    contrast_hover: {
      value: {
        _dark: "{colors.primary.100}",
        _light: "{colors.primary.600}",
      },
    },
    cta_bg: {
      value: {
        _dark: "{colors.primary.400}",
        _light: "{colors.primary.500}",
      },
    },
    cta_bg_hover: {
      value: {
        _dark: "{colors.primary.500}",
        _light: "{colors.primary.600}",
      },
    },
    cta_contrast: {
      value: {
        _dark: "{colors.white}",
        _light: "{colors.white}",
      },
    },
    cta_contrast_hover: {
      value: {
        _dark: "{colors.primary.50}",
        _light: "{colors.primary.500}",
      },
    },
    hover: {
      value: {
        _dark: "{colors.primary.700}",
        _light: "{colors.primary.100}",
      },
    },
  },
  orange: {
    contrast: {
      value: {
        _dark: "black",
        _light: "white",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.orange.700}",
        _light: "{colors.orange.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.orange.300}",
        _light: "{colors.orange.700}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.orange.500}",
        _light: "{colors.orange.600}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.orange.800}",
        _light: "{colors.orange.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.orange.500}",
        _light: "{colors.orange.600}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.orange.900}",
        _light: "{colors.orange.100}",
      },
    },
  },
  pink: {
    contrast: {
      value: {
        _dark: "white",
        _light: "white",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.pink.700}",
        _light: "{colors.pink.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.pink.300}",
        _light: "{colors.pink.700}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.pink.600}",
        _light: "{colors.pink.600}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.pink.800}",
        _light: "{colors.pink.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.pink.600}",
        _light: "{colors.pink.600}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.pink.900}",
        _light: "{colors.pink.100}",
      },
    },
  },
  primary: {
    contrast: {
      value: {
        _dark: "white",
        _light: "white",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.primary.700}",
        _light: "{colors.primary.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.primary.300}",
        _light: "{colors.primary.700}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.primary.600}",
        _light: "{colors.primary.600}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.primary.800}",
        _light: "{colors.primary.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.primary.400}",
        _light: "{colors.primary.600}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.primary.900}",
        _light: "{colors.primary.100}",
      },
    },
  },
  purple: {
    contrast: {
      value: {
        _dark: "white",
        _light: "white",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.purple.700}",
        _light: "{colors.purple.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.purple.300}",
        _light: "{colors.purple.700}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.purple.600}",
        _light: "{colors.purple.600}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.purple.800}",
        _light: "{colors.purple.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.purple.600}",
        _light: "{colors.purple.600}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.purple.900}",
        _light: "{colors.purple.100}",
      },
    },
  },
  red: {
    contrast: {
      value: {
        _dark: "white",
        _light: "white",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.red.700}",
        _light: "{colors.red.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.red.300}",
        _light: "{colors.red.700}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.red.600}",
        _light: "{colors.red.600}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.red.800}",
        _light: "{colors.red.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.red.600}",
        _light: "{colors.red.600}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.red.900}",
        _light: "{colors.red.100}",
      },
    },
  },
  secondary: {
    contrast: {
      value: {
        _dark: "white",
        _light: "white",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.secondary.700}",
        _light: "{colors.secondary.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.secondary.300}",
        _light: "{colors.secondary.700}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.secondary.600}",
        _light: "{colors.secondary.600}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.secondary.800}",
        _light: "{colors.secondary.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.secondary.600}",
        _light: "{colors.secondary.600}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.secondary.900}",
        _light: "{colors.secondary.100}",
      },
    },
  },
  skill: {
    svg_logo: {
      value: {
        _dark: "{colors.black}",
        _light: "{colors.white}",
      },
    },
  },
  stickers_bg: {
    blue: {
      value: {
        _dark: "{colors.blue.800}",
        _light: "{colors.blue.100}",
      },
    },
    cyan: {
      value: {
        _dark: "{colors.cyan.800}",
        _light: "{colors.cyan.100}",
      },
    },
    green: {
      value: {
        _dark: "{colors.green.800}",
        _light: "{colors.green.100}",
      },
    },
    orange: {
      value: {
        _dark: "{colors.orange.800}",
        _light: "{colors.orange.100}",
      },
    },
    pink: {
      value: {
        _dark: "{colors.pink.800}",
        _light: "{colors.pink.100}",
      },
    },
    purple: {
      value: {
        _dark: "{colors.purple.800}",
        _light: "{colors.purple.100}",
      },
    },
    teal: {
      value: {
        _dark: "{colors.teal.800}",
        _light: "{colors.teal.100}",
      },
    },
  },
  stickers_fg: {
    blue: {
      value: {
        _dark: "{colors.blue.400}",
        _light: "{colors.blue.600}",
      },
    },
    cyan: {
      value: {
        _dark: "{colors.cyan.400}",
        _light: "{colors.cyan.600}",
      },
    },
    green: {
      value: {
        _dark: "{colors.green.400}",
        _light: "{colors.green.600}",
      },
    },
    orange: {
      value: {
        _dark: "{colors.orange.400}",
        _light: "{colors.orange.600}",
      },
    },
    pink: {
      value: {
        _dark: "{colors.pink.400}",
        _light: "{colors.pink.600}",
      },
    },
    purple: {
      value: {
        _dark: "{colors.purple.400}",
        _light: "{colors.purple.600}",
      },
    },
    teal: {
      value: {
        _dark: "{colors.teal.400}",
        _light: "{colors.teal.600}",
      },
    },
  },
  teal: {
    contrast: {
      value: {
        _dark: "white",
        _light: "white",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.teal.700}",
        _light: "{colors.teal.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.teal.300}",
        _light: "{colors.teal.700}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.teal.600}",
        _light: "{colors.teal.600}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.teal.800}",
        _light: "{colors.teal.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.teal.600}",
        _light: "{colors.teal.600}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.teal.900}",
        _light: "{colors.teal.100}",
      },
    },
  },
  tertiary: {
    contrast: {
      value: {
        _dark: "white",
        _light: "white",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.tertiary.700}",
        _light: "{colors.tertiary.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.tertiary.300}",
        _light: "{colors.tertiary.700}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.tertiary.600}",
        _light: "{colors.tertiary.600}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.tertiary.800}",
        _light: "{colors.tertiary.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.tertiary.600}",
        _light: "{colors.tertiary.600}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.tertiary.900}",
        _light: "{colors.tertiary.100}",
      },
    },
  },
  yellow: {
    contrast: {
      value: {
        _dark: "black",
        _light: "black",
      },
    },
    emphasized: {
      value: {
        _dark: "{colors.yellow.700}",
        _light: "{colors.yellow.300}",
      },
    },
    fg: {
      value: {
        _dark: "{colors.yellow.300}",
        _light: "{colors.yellow.800}",
      },
    },
    focusRing: {
      value: {
        _dark: "{colors.yellow.300}",
        _light: "{colors.yellow.300}",
      },
    },
    muted: {
      value: {
        _dark: "{colors.yellow.800}",
        _light: "{colors.yellow.200}",
      },
    },
    solid: {
      value: {
        _dark: "{colors.yellow.300}",
        _light: "{colors.yellow.300}",
      },
    },
    subtle: {
      value: {
        _dark: "{colors.yellow.900}",
        _light: "{colors.yellow.100}",
      },
    },
  },
  // brand: {
  //   solid: { value: "{colors.primary.500}" },
  //   contrast: { value: "{colors.primary.100}" },
  //   fg: { value: "{colors.primary.700}" },
  //   muted: { value: "{colors.primary.100}" },
  //   subtle: { value: "{colors.primary.200}" },
  //   emphasized: { value: "{colors.primary.300}" },
  //   focusRing: { value: "{colors.primary.500}" },
  // },
})
